export enum TextWizardStatus {
  UPLOADING_TEXT = 'UPLOADING_TEXT',
  CREATING_TRANSCRIPT = 'CREATING_TRANSCRIPT',
  ANALYZING_TEXT = 'ANALYZING_TEXT',
  CREATING_CONFIGURATION = 'CREATING_CONFIGURATION',
  CREATING_PROJECT = 'CREATING_PROJECT',
  SUMMARIZING = 'SUMMARIZING',
  FINISHED = 'FINISHED',
}
